// extracted by mini-css-extract-plugin
export default {"AboutDescription":"AboutDescription_AboutDescription__TVNA+","about_shape":"AboutDescription_about_shape__kqNsb","responsive_shape":"AboutDescription_responsive_shape__NBbAU"};